import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';

import {
    autocompleter,
    AUTOCOMPLETER_STATE_SLICE_KEY,
} from 'SearchApp/ts/features/base-autocomplete/state/autocompleter.reducer';

import { AppendToBodyModule } from 'Angular/features/directives/append-to-body/append-to-body.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { IndexOfPipeModule } from 'Angular/features/pipes/index-of/index-of-pipe.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';

import { BaseAutocompleteComponent } from './components/base-autocomplete.component';
import { CategoriesResultsComponent } from './components/categories-results.component';
import { ExtraLinksComponent } from './components/extra-links.component';
import { ListResultsComponent } from './components/list-results.component';
import { SearchBarComponent } from './components/search-bar.component';
import { DisabledDirective } from 'Angular/features/directives/disabled/disabled.directive';

@NgModule({
    imports: [
        AppendToBodyModule,
        CommonModule,
        DisabledModule,
        TooltipModule,
        FeatureNeededModule,
        FormsModule,
        IconModule,
        IndexOfPipeModule,
        StoreModule.forFeature(AUTOCOMPLETER_STATE_SLICE_KEY, autocompleter),
    ],
    declarations: [
        BaseAutocompleteComponent,
        CategoriesResultsComponent,
        ExtraLinksComponent,
        ListResultsComponent,
        SearchBarComponent,
    ],
    exports: [
        BaseAutocompleteComponent,
        CategoriesResultsComponent,
        ExtraLinksComponent,
        ListResultsComponent,
        SearchBarComponent,
        DisabledDirective,
    ],
})
export class BaseAutocompleteModule {}
